import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "React_BrandLib";
import * as selectors from "../selectors";

const AsyncButton = (props) => <Button {...props} />;

const mapStateToProps = (state, ownProps) => {
	const { typeName } = ownProps;
	const apiProps = typeName ? selectors.getTypeState(typeName)(state) : {};
	return apiProps;
};

AsyncButton.propTypes = {
	// Call API Action Type Name
	typeName: PropTypes.string
};

export default connect(mapStateToProps)(AsyncButton);
